import { getProductListData, _getPRDataById } from '../products/mockData'
import { getTsdContactListData, _getTCTDataById } from '../tsdContacts/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import {
  getOrderListData,
  getOrderDataById,
  getOrderOverviewData,
} from '../orders/mockData'
import { getOrderMasterServiceDataById } from '../orderMasterServices/mockData'
import { getCompanyDataById } from '../companies/mockData'
import { _storeEntityDataListToLocalForage } from '../../modules/mockDataStorageManager'
import { getSupplierProductListData } from '../supplierProducts/mockData'
import { getSupplierProductItemListData } from '../supplierProductItems/mockData'
import { getOrderMSServiceDocumentListDataByOMSSId } from '../orderMSServiceDocuments/mockData'
import type { TEntityId } from '~/types/models'
import type { IOrderMasterService, IOrderMSService } from '~/types/order/models'
import type { TMasterService } from '~/types/masterService/models'
import type { IContract } from '~/types/contract/models'
import type { TProduct } from '~/types/product/models'
import type { ISupplierProduct } from '~/types/supplierProduct/models'
import type { ISupplierProductItem } from '~/types/supplierProductItem/models'
import { assertIsNotUndefined, assertIsString } from '~/types/models'
import {
  getOrderMSServiceStatusById,
  OrderMSServicesStatusIds,
} from '~/services/selectLists/orderMSServicesStatii'
import { getRecursPaidIntervalByLabel } from '~/services/selectLists'
import {
  getItemAvailabilityStateById,
  ItemAvailabilityIds,
} from '~/cynqueModules/dataObjects/ItemAvailabilityStatus'
import {
  MSService,
  buildMSServicesById,
} from '~/cynqueModules/dataObjects/MSService'
import { setKeyIdentifierValues } from '../../modules/setKeyIdentifierValues'
import { ContractStatusIds } from '~/services/selectLists/contractStatii'
import { propagateMOMSServicesData } from '~/cynqueModules/dataObjects/OrderMSService'
import { propagateOrderServiceOrderData } from '~/cynqueModules/dataObjects/OrderServiceOrder'
import { getOrderMSServiceNoteListDataByOMSSId } from '../orderMSServiceNotes/mockData'

const mn = '[api/msw/api/orderMSServices/mockData.ts]'

const orderMSServiceListData = undefined as unknown as IOrderMSService[]

export const getOrderMSServiceListData = getListDataFunctionFactory<
  IOrderMSService[]
>({
  listData: orderMSServiceListData,
  storageKey: 'ordermsservices',
  getStartingListData: getStartingOrderMSServiceListData,
})

export async function getOrderMSServiceDataById(
  id: string
): Promise<IOrderMSService> {
  const list = await getOrderMSServiceListData()
  if (!list) {
    throw new Error(`getOrderMSServiceListData returned undefined/null`)
  }
  const momss = list.find((momss: IOrderMSService) => momss.id === id)
  if (!momss) {
    throw new Error(`Can't find orderMSService for id '${id}'`)
  }
  await setKeyIdentifierValues([momss])
  return momss
}

export async function _getMOMSSListDataByMOMSId(
  id: TEntityId,
  list: IOrderMSService[]
): Promise<IOrderMSService[]> {
  if (!list) {
    throw new Error(`_getOMSSListDataByMOMSId called with undefined/null list`)
  }
  const momssList = list.filter(
    (momss: IOrderMSService) => momss.masterService.id === id
  )
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  // console.debug(id, momssList)
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  if (!momssList) {
    throw new Error(
      `Can't find any orderMSServices for masterService id '${id}'`
    )
  }
  for (const momss of momssList) {
    momss.orderMSServiceDocuments =
      await getOrderMSServiceDocumentListDataByOMSSId(momss.id)
    momss.orderMSServiceNotes = await getOrderMSServiceNoteListDataByOMSSId(
      momss.id
    )
  }
  await setKeyIdentifierValues(momssList)
  return momssList
}

export async function getOrderMSServiceListDataByMOMSId(
  id: string
): Promise<IOrderMSService[]> {
  const list = await getOrderMSServiceListData()
  return _getMOMSSListDataByMOMSId(id, list)
}

export async function getMOMSSListDataByContractId(
  id: TEntityId
): Promise<IOrderMSService[]> {
  const list = await getOrderMSServiceListData()
  if (!list) {
    throw new Error(`getOrderMSServiceListData returned undefined`)
  }
  const momssList = list.filter(
    (momss: IOrderMSService) => momss.contract?.id === id
  )
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  // console.debug(id, momssList)
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  if (!momssList) {
    throw new Error(`Can't find any orderMSServices for contract id '${id}'`)
  }
  await setKeyIdentifierValues(momssList)
  return momssList
}

export async function updateMOMSSsOnContractIfContractWasAccepted({
  targetItem,
  updatedEntityData,
}: {
  targetItem: IContract
  updatedEntityData: Partial<IContract>
}) {
  const fn = `${mn} updateMOMSSsOnContractIfContractWasAccepted |`
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  // console.debug(targetItem, updatedEntityData)
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  if (!('status' in updatedEntityData)) {
    console.debug(
      `${fn} 'status' was not in updatedEntityData. Not changing status in MOMSSs`
    )
    return
  }
  console.debug(`${fn} 'status' -WAS- in updatedEntityData. Updating MOMSSs.`)
  const momssList = await getMOMSSListDataByContractId(targetItem.id)
  assertIsNotUndefined(momssList)
  if (targetItem.status.id === ContractStatusIds.ACCEPTED) {
    let somethingChanged = false
    momssList.forEach((momss) => {
      if (
        momss.status.id === OrderMSServicesStatusIds.PREORDER_UNLOCKED ||
        momss.status.id === OrderMSServicesStatusIds.PREORDER_LOCKED
      ) {
        console.debug(
          `${fn} Updating ${momss.status.label} to READY_FOR_SERVICES.`
        )
        somethingChanged = true
        momss.status = getOrderMSServiceStatusById(
          OrderMSServicesStatusIds.READY_FOR_SERVICEORDER
        )
      }
    })
    if (!somethingChanged) {
      // Should always be true. (Belt and suspenders.)
      return
    }
    await _storeEntityDataListToLocalForage({
      entityKeyBase: 'ordermsservices',
      listData: momssList,
      callingFn: fn,
    })
  }
}

export async function getMOMSSListDataByOrderServiceOrderId(
  id: TEntityId
): Promise<IOrderMSService[]> {
  const list = await getOrderMSServiceListData()
  if (!list) {
    throw new Error(`getOrderMSServiceListData returned undefined`)
  }
  const momssList = list.filter(
    (momss: IOrderMSService) => momss.orderServiceOrder?.id === id
  )
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  // console.debug(id, momssList)
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  if (!momssList) {
    throw new Error(
      `Can't find any orderMSServices for orderServiceOrder id '${id}'`
    )
  }
  await setKeyIdentifierValues(momssList)
  return momssList
}

export async function getCompanyDataByOrderMSServiceId(id: string) {
  const momss = await getOrderMSServiceDataById(id)
  if (!momss) {
    throw new Error(`getOrderMSServiceDataById returned undefined/null`)
  }
  assertIsString(momss.masterService.id)
  const moms = await getOrderMasterServiceDataById(momss.masterService.id)
  if (!moms) {
    throw new Error(`getOrderMasterSServiceDataById returned undefined/null`)
  }
  assertIsString(moms.order.id)
  const order = await getOrderDataById(moms.order.id)
  if (!moms) {
    throw new Error(`getOrderMasterSServiceDataById returned undefined/null`)
  }
  assertIsString(order.company.id)
  const company = await getCompanyDataById(order.company.id)
  if (!company) {
    throw new Error(`getCompanyDataById returned undefined/null`)
  }
  return company
}

export async function updateMasterServiceInOrderMSServices({
  targetItem: masterService,
}: {
  targetItem: TMasterService
}) {
  const fn = `${mn} updateMasterServiceInOrderMSServices |`
  const list: IOrderMSService[] = await getOrderMSServiceListData()
  if (!list) {
    throw new Error(`getOrderMSServiceListData returned undefined/null`)
  }
  for (const orderMSService of list) {
    if (orderMSService.masterService.id === masterService.id) {
      console.debug(
        `${fn} updating masterService.label in orderMSService ` +
          ` from ${orderMSService.masterService.label} to ${masterService.descr}`
      )
      orderMSService.masterService = {
        id: masterService.id,
        label: masterService.descr,
        parent: orderMSService.masterService.parent,
      }
    }
  }
  await _storeEntityDataListToLocalForage({
    entityKeyBase: 'ordermsservices',
    listData: list,
    callingFn: fn,
  })
}

//
// Propagation Methods
//

export async function propagateOrderMSServiceOrServicesAdditions({
  newEntityData,
}: {
  newEntityData: IOrderMSService | IOrderMSService[]
}) {
  const fn = `${mn} propagateOrderMSServiceOrServicesAdditions |`
  if (!newEntityData) {
    console.debug(`${fn} newEntityData is falsey. Nothing to propagate.`)
    return
  }
  if (Array.isArray(newEntityData)) {
    if (newEntityData.length < 1) {
      console.debug(
        `${fn} newEntityData is an empty array. Nothing to propagate.`
      )
      return
    }
    _propagateOrderMSServiceAdditionsChangesOrDeletions({
      orderMSService: newEntityData[0],
    })
    return
  }
  _propagateOrderMSServiceAdditionsChangesOrDeletions({
    orderMSService: newEntityData,
  })
}

export async function propagateOrderMSServicesChanges({
  updatedEntityDataMultiple,
}: {
  updatedEntityDataMultiple: Partial<IOrderMSService>[]
}) {
  const fn = `${mn} propagateOrderMSServicesChanges |`
  if (
    !updatedEntityDataMultiple ||
    !Array.isArray(updatedEntityDataMultiple) ||
    updatedEntityDataMultiple.length < 1
  ) {
    console.debug(
      `${fn} updatedEntityDataMultiple is falsey ` +
        ` or an empty array. Nothing to propagate.`
    )
    return
  }
  const updatedEntityData = updatedEntityDataMultiple[0]
  if (!updatedEntityData) {
    throw new Error(
      `${fn} updatedEntityData is falsey after testing truthy.` +
        ` This should never happen.`
    )
  }
  assertIsString(updatedEntityData.id) // Should always be
  const momss = await getOrderMSServiceDataById(updatedEntityData.id)
  if (!momss) {
    throw new Error(`getOrderMSServiceDataById returned undefined/null`)
  }
  _propagateOrderMSServiceAdditionsChangesOrDeletions({
    orderMSService: momss,
  })
}

export async function propagateOrderMSServiceChanges({
  targetItem,
}: {
  targetItem: IOrderMSService
}) {
  const fn = `${mn} propagateOrderMSServiceChanges |`
  if (!targetItem) {
    console.debug(`${fn} targetItem is falsey. Nothing to propagate.`)
    return
  }
  _propagateOrderMSServiceAdditionsChangesOrDeletions({
    orderMSService: targetItem,
  })
}

export async function propagateOrderMSServiceDeletions({
  deletedEntityData,
}: {
  deletedEntityData: IOrderMSService
}) {
  const fn = `${mn} propagateOrderMSServiceDeletions |`
  if (!deletedEntityData) {
    console.debug(`${fn} deletedEntityData is falsey. Nothing to propagate.`)
    return
  }
  _propagateOrderMSServiceAdditionsChangesOrDeletions({
    orderMSService: deletedEntityData,
  })
}

async function _propagateOrderMSServiceAdditionsChangesOrDeletions({
  orderMSService,
}: {
  orderMSService: IOrderMSService
}) {
  function _setUpOrderMSServices() {
    const msServicesById = buildMSServicesById(allMOMSServices)
    allMOMSServices.forEach((momsService) => {
      momsService = Object.assign(
        momsService,
        MSService(momsService, allMOMSServices, msServicesById)
        // Note: There are some properties being set by MSService
        // that really don't need to be set server-side, cause
        // they're for display only, but don't want to wrangle
        // two versions of the MSService dataObject so leaving
        // this be for the moment.
      )
    })
  }
  //
  // Execution begins here
  //
  const fn = `${mn} _propagateOrderMSServiceAdditionsChangesOrDeletions |`
  if (!orderMSService) {
    console.debug(`${fn} orderMSService is falsey. Nothing to propagate.`)
    return
  }
  const moms = await getOrderMasterServiceDataById(
    orderMSService.masterService.id
  )
  if (!moms) {
    throw new Error(`getOrderMasterServiceDataById returned undefined/null`)
  }
  const order = await getOrderDataById(moms.order.id)
  if (!order) {
    throw new Error(`getOrderDataById returned undefined/null`)
  }
  const overviewData = await getOrderOverviewData(order.id)
  assertIsNotUndefined(overviewData)
  console.debug(`${fn} overviewData:`, overviewData)

  const allMOMSServices: IOrderMSService[] = overviewData.orderMasterServices
    .filter((ms: IOrderMasterService) => !!ms.orderMSServices)
    .map((ms: TMasterService) => ms.orderMSServices)
    .flat()
  console.debug(`${fn} all mmomss:`, allMOMSServices)

  propagateMOMSServicesData({
    overviewData,
    allMOMSServices,
    setUpOrderMSServices: _setUpOrderMSServices,
  })
  console.debug(`${fn} order after propagation:`, overviewData.order)

  const orderList = await getOrderListData()
  if (!orderList) {
    throw new Error(`getOrderListData returned undefined/null`)
  }
  await _storeEntityDataListToLocalForage({
    entityKeyBase: 'order',
    listData: orderList,
    callingFn: fn,
  })

  // Note: I don't understand why I don't have to do the same as above
  // for orderMasterServices (get the list and call _store{blah}).
  // The value in localForage -is- getting changed somehow. Even weirder,
  // I -do- have to do that for propagation of companyMSServices
  // changes.  JR
}

//
//
//

export async function getStartingOrderMSServiceListData(): Promise<
  IOrderMSService[]
> {
  const stListData = await getProductListData()
  const tctListData = await getTsdContactListData()

  const pr0007 = await _getPRDataById('XXPR0007', stListData, true)
  const pr0035 = await _getPRDataById('XXPR0035', stListData, true)

  if (!pr0007 || !pr0035) {
    throw new Error('Some mock data products are falsey')
  }

  function isDefined<T>(
    value: NonNullable<T> | undefined | null
  ): value is NonNullable<T> {
    return value !== null && value !== undefined
  }

  function isEachItemDefined<T>(
    value: Array<NonNullable<T> | undefined | null>
  ): value is Array<NonNullable<T>> {
    return value.every(isDefined)
  }

  const stArray = []
  for (let i = 35; i < 64; i++) {
    if (i === 41) {
      continue
    }
    const id = `${'XXPR00'}${('00' + i.toString()).slice(-2)}`
    stArray[i] = await _getPRDataById(id, stListData, true)
  }

  if (!isEachItemDefined<TProduct>(stArray)) {
    throw new Error('Some mock data service types are falsey')
  }

  const spListData: ISupplierProduct[] = await getSupplierProductListData()
  const spiListData: ISupplierProductItem[] =
    await getSupplierProductItemListData()

  function findSPI(
    productId: string,
    supplierId: string
  ): ISupplierProductItem | undefined {
    return spiListData.find(
      (spi) =>
        spi.product.id === productId &&
        spi.supplierProduct.supplier.id === supplierId
    )
  }

  function findSP(
    productId: string,
    supplierId: string
  ): ISupplierProduct | undefined {
    return spListData.find(
      (sp) => sp.product.id === productId && sp.supplier.id === supplierId
    )
  }

  //
  //  START MOCK DATA  START MOCK DATA  START MOCK DATA
  //
  //

  return [
    {
      id: 'XXORDMSS0021',
      hrid: 'ORDMSS0021',
      descr: findSP(stArray[35].id, 'XXS0002')?.descr || stArray[35].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[35],
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0003',
        label: 'Target',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProduct: (() => {
        const _sp = findSP(stArray[35].id, 'XXS0002')
        return _sp ? { id: _sp.id, label: _sp.descr } : undefined
      })(),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0003', label: 'DIA - Target & Big Mac' },
      orderServiceOrder: {
        id: 'XXORDSO0001',
        label: 'ORDSO9001 | Cogent | #CSO11111 | Cogent SO 1',
      },
      osomsAcceptedOnDate: '2025-04-01',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(OrderMSServicesStatusIds.ACCEPTED)!,
      doInclude: true,
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0028',
      hrid: 'ORDMSS0028',
      descr: findSPI(stArray[44].id, 'XXS0002')?.descr || stArray[44].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[44],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0021',
      location: {
        id: 'XXL0003',
        label: 'Target',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[44].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0003', label: 'DIA - Target & Big Mac' },
      orderServiceOrder: {
        id: 'XXORDSO0001',
        label: 'ORDSO9001 | Cogent | #CSO11111 | Cogent SO 1',
      },
      osomsAcceptedOnDate: '2025-04-01',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 60,
      mrcAmount: 0,
      unitNrcAmount: 500,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(OrderMSServicesStatusIds.ACCEPTED)!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0034',
      hrid: 'ORDMSS0034',
      descr: findSPI(stArray[51].id, 'XXS0002')?.descr || stArray[51].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[51],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0021',
      location: {
        id: 'XXL0003',
        label: 'Target',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[51].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0003', label: 'DIA - Target & Big Mac' },
      orderServiceOrder: {
        id: 'XXORDSO0001',
        label: 'ORDSO9001 | Cogent | #CSO11111 | Cogent SO 1',
      },
      osomsAcceptedOnDate: '2025-04-01',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 100,
      mrcAmount: 0,
      unitNrcAmount: 1000,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(OrderMSServicesStatusIds.ACCEPTED)!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0038',
      hrid: 'ORDMSS0038',
      descr: findSPI(stArray[56].id, 'XXS0002')?.descr || stArray[56].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[56],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0021',
      location: {
        id: 'XXL0003',
        label: 'Target',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[56].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0003', label: 'DIA - Target & Big Mac' },
      orderServiceOrder: {
        id: 'XXORDSO0001',
        label: 'ORDSO9001 | Cogent | #CSO11111 | Cogent SO 1',
      },
      osomsAcceptedOnDate: '2025-04-01',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 79,
      mrcAmount: 0,
      unitNrcAmount: 150,
      nrcAmount: 0,
      oneTimeAmount: 250,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(OrderMSServicesStatusIds.ACCEPTED)!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0044',
      hrid: 'ORDMSS0044',
      descr: findSPI(stArray[62].id, 'XXS0002')?.descr || stArray[62].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[62],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0021',
      location: {
        id: 'XXL0003',
        label: 'Target',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[62].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0003', label: 'DIA - Target & Big Mac' },
      orderServiceOrder: {
        id: 'XXORDSO0001',
        label: 'ORDSO9001 | Cogent | #CSO11111 | Cogent SO 1',
      },
      osomsAcceptedOnDate: '2025-04-01',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(OrderMSServicesStatusIds.ACCEPTED)!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    //
    // Cogent / Lake
    //
    {
      id: 'XXORDMSS0071',
      hrid: 'ORDMSS0071',
      descr: findSP(stArray[35].id, 'XXS0002')?.descr || stArray[35].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[35],
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0002',
        label: 'Big Mac',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProduct: (() => {
        const _sp = findSP(stArray[35].id, 'XXS0002')
        return _sp ? { id: _sp.id, label: _sp.descr } : undefined
      })(),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.READY_FOR_CONTRACT
      )!,
      doInclude: true,
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0078',
      hrid: 'ORDMSS0078',
      descr: findSPI(stArray[44].id, 'XXS0002')?.descr || stArray[44].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[44],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0071',
      location: {
        id: 'XXL0002',
        label: 'Big Mac',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[44].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 60,
      mrcAmount: 0,
      unitNrcAmount: 500,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.READY_FOR_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0084',
      hrid: 'ORDMSS0084',
      descr: findSPI(stArray[51].id, 'XXS0002')?.descr || stArray[51].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[51],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0071',
      location: {
        id: 'XXL0002',
        label: 'Big Mac',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[51].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 100,
      mrcAmount: 0,
      unitNrcAmount: 1000,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.READY_FOR_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0088',
      hrid: 'ORDMSS0088',
      descr: findSPI(stArray[56].id, 'XXS0002')?.descr || stArray[56].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[56],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0071',
      location: {
        id: 'XXL0002',
        label: 'Big Mac',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[56].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 79,
      mrcAmount: 0,
      unitNrcAmount: 150,
      nrcAmount: 0,
      oneTimeAmount: 250,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.READY_FOR_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0094',
      hrid: 'ORDMSS0094',
      descr: findSPI(stArray[62].id, 'XXS0002')?.descr || stArray[62].descr,
      masterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
        parent: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[62],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0071',
      location: {
        id: 'XXL0002',
        label: 'Big Mac',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[62].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.READY_FOR_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    /**
     * WALTHAM -- the order side of the signed contract XXCON0006, on the new
     * order XXORD0002 (NOT XXORD0001; see that entry's comment in
     * api/msw/api/orders/mockData.ts for why the two orders stay separate).
     *
     * Cloned from opportunity rows XXOMSS0131..0135 by the routine that runs
     * when a contract is signed: `contractUpdated` (SiloOverview.ts) ->
     * `buildOrderOverviewForPostFromOpportunityOverview` ->
     * POST /api/orders/overview. These rows are what that routine produces, so
     * they are seeded rather than left for it to create -- a signed contract
     * whose services never reached an order is a state the app does not leave
     * behind, and `_getSignedUnclonedNonMSAContractsInOpportunityOverview`
     * would keep selecting XXCON0006 as still owing one.
     *
     * Field-for-field from `_buildOrderMSServicesFromOpportunityMSServices`:
     *  - `status` becomes PREORDER_LOCKED regardless of the source status;
     *  - `contract` is carried across unchanged (XXCON0006);
     *  - `parentMSServiceId` is REMAPPED to the new order-side ids, not copied,
     *    so the kit keeps its shape under XXORDMSS0131;
     *  - `opportunityMSService` back-references the row each came from;
     *  - amounts, quantity, kitQuantity, term and availability are copied as-is.
     */
    {
      id: 'XXORDMSS0131',
      hrid: 'ORDMSS0131',
      descr: findSP(stArray[35]!.id, 'XXS0002')?.descr || stArray[35]!.descr,
      masterService: {
        id: 'XXORDMS0002',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXORD0002', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[35]!,
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProduct: (() => {
        const _sp = findSP(stArray[35]!.id, 'XXS0002')
        return _sp ? { id: _sp.id, label: _sp.descr! } : undefined
      })(),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.PREORDER_LOCKED
      )!,
      doInclude: true,
      opportunityMSService: {
        id: 'XXOMSS0131',
        label: 'Cogent DIA (Kit)',
      },
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0132',
      hrid: 'ORDMSS0132',
      descr: findSPI(stArray[44]!.id, 'XXS0002')?.descr || stArray[44]!.descr,
      masterService: {
        id: 'XXORDMS0002',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXORD0002', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[44]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[44]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 60,
      mrcAmount: 0,
      unitNrcAmount: 500,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.PREORDER_LOCKED
      )!,
      doInclude: true,
      opportunityMSService: {
        id: 'XXOMSS0132',
        label: 'Cogent Port - 1Gb',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0133',
      hrid: 'ORDMSS0133',
      descr: findSPI(stArray[51]!.id, 'XXS0002')?.descr || stArray[51]!.descr,
      masterService: {
        id: 'XXORDMS0002',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXORD0002', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[51]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[51]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 100,
      mrcAmount: 0,
      unitNrcAmount: 1000,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.PREORDER_LOCKED
      )!,
      doInclude: true,
      opportunityMSService: {
        id: 'XXOMSS0133',
        label: 'Cogent Access - 1Gb',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0134',
      hrid: 'ORDMSS0134',
      descr: findSPI(stArray[56]!.id, 'XXS0002')?.descr || stArray[56]!.descr,
      masterService: {
        id: 'XXORDMS0002',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXORD0002', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[56]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[56]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 79,
      mrcAmount: 0,
      unitNrcAmount: 150,
      nrcAmount: 0,
      oneTimeAmount: 250,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.PREORDER_LOCKED
      )!,
      doInclude: true,
      opportunityMSService: {
        id: 'XXOMSS0134',
        label: 'Cogent IP Block - /29',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDMSS0135',
      hrid: 'ORDMSS0135',
      descr: findSPI(stArray[62]!.id, 'XXS0002')?.descr || stArray[62]!.descr,
      masterService: {
        id: 'XXORDMS0002',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXORD0002', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: stArray[62]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXORDMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(stArray[62]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOrderMSServiceStatusById(
        OrderMSServicesStatusIds.PREORDER_LOCKED
      )!,
      doInclude: true,
      opportunityMSService: {
        id: 'XXOMSS0135',
        label: 'Cogent Fiber Converter',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
